module.exports = __webpack_public_path__ + "static/whiteroom_logo-2d703445954bec1dfffc1431aa03bc86.png";